var v6ToV1 = {};

export { v6ToV1 as __exports };
//# sourceMappingURL=v6ToV1.js.map
